import { useCurrentUserStorage } from '@pn/core/storage';
import { stringifyUserId } from '@pn/services/loggers/appSignalErrorLogger';
import { ErrorBoundary } from './AppSignalErrorBoundary';
import { appsignal } from './appSignalManager';

export type ErrorPageProps = {
  error: Error | undefined;
};

type Props = {
  children: React.ReactNode;
  errorPage: ({ error }: ErrorPageProps) => React.ReactNode;
};

/**
 * Only React render errors are caught here.
 * Reference: https://reactjs.org/docs/error-boundaries.html
 *
 * {@link https://github.com/appsignal/appsignal-javascript/blob/main/packages/react/src/ErrorBoundary.tsx}
 */
export const ErrorBoundaryProvider = ({
  children,
  errorPage: ErrorPage,
}: Props) => {
  const { user } = useCurrentUserStorage();

  return (
    <ErrorBoundary
      instance={appsignal}
      tags={{ userId: stringifyUserId(user?.id) }}
      fallback={(error) => <ErrorPage error={error} />}
    >
      {children}
    </ErrorBoundary>
  );
};
